import {
  shape, arrayOf, number, bool,
} from 'prop-types';

export const promocionType = shape({
  id: number,
  paraLentesGenericas: bool,
});

export const promocionesType = arrayOf(promocionType);
